import axios from '../axios';

class Api {
    static getDetailvoorspelling (voorspellingsplaatsId, dagverschil) {
        return axios.get(`/detailvoorspelling/fromplaats?voorspellingsplaats_id=${voorspellingsplaatsId}&dagverschil=${dagverschil}`);
    }

    static getDagvoorspelling (voorspellingsplaatsId) {
        return axios.get(`/dagvoorspelling/fromplaats?voorspellingsplaats_id=${voorspellingsplaatsId}`);
    }
}

export default Api;



// WEBPACK FOOTER //
// ./src/api/voorspelling.js